import React from 'react';
import { IconButton, Tooltip } from '@mui/material';

const ToggleButton = ({
  label,
  checked,
  onChange,
  icon,
  styles,
  nor = false,
}: {
  label: string;
  checked: boolean;
  onChange: (value: boolean) => void;
  icon: React.ReactNode;
  styles?: React.CSSProperties;
  nor?: boolean;
}) => {
  return (
    <Tooltip title={checked ? `Show ${label}` : `Hide ${label}`}>
      <IconButton
        onClick={() => onChange(!checked)}
        sx={{
          cursor: 'pointer',
          borderRadius: '.25rem',
          padding: '.25rem',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          width: '2rem',
          height: '2rem',
          color: '#888',
          marginRight: '1rem',
          '&:hover': {
            backgroundColor: '#f3f3f3',
          },

          border: `.1rem solid ${nor ? (!checked ? 'orange' : '#d3d3d3') : checked ? 'orange' : '#d3d3d3'}`,
          ...(styles || {}),
        }}>
        {icon}
      </IconButton>
    </Tooltip>
  );
};

export default ToggleButton;
